import React, { Suspense } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { useNavigate } from 'react-router-dom';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { api } from '../../redux/config';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import BukaLapak from '../../asset/Bukalapak Logo.webp';
import Kemnaker from '../../asset/Kemnaker Logo.webp';
import Tokopedia from '../../asset/Tokopedia Logo.webp';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import * as actionTypesMateri from '../../redux/action/materiAction';
import * as actionTypesBackdrop from '../../redux/action/backdropAction';
import * as actionTypesModal from '../../redux/action/modalAction';
import { useModal, useHideModal } from './ModalHooks';
import CheckIcon from '@material-ui/icons/Check';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { InputLabel, OutlinedInput } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
    image: {
        [theme.breakpoints.up('sm')]: {
            height: '400px',
            width: '300px'
        },
        height: '300px',
        width: '200px'
    },
    dialog: {
        zIndex: '1300 !important'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

const ModalWrapper = ({showBackdropAction, hideBackdropAction, showModalAction}) => {
    const navigate = useNavigate();
    const classes = useStyles();
    // Get modal params from redux store
    const [value, setValue] = React.useState(null);
    const modal = useModal().modal.payload.modalReducer;
    const { handleOnClose } = useHideModal();

    const handleSubmit = () => {
        handleOnClose();
        showBackdropAction();
        if(modal.type === "Alerts"){
            hideBackdropAction();
            modal.showModal()
        }
        if(modal.action){
            if(modal.type === "Register"){
                modal.action(modal.actiondata, modal.nextModal);
            }
            else if(modal.type === "Alert"){
                hideBackdropAction();
                modal.action(modal.actiondata);
            }
            else{
                modal.action(modal.actiondata, navigate);
            }
        }
        if(modal.type === "Done" && modal.path === null){
            api.post('/monitoring/video-view', {
                material_id: modal.id,
                time: modal.time,
                status: '1',
            })
                .then(response => {
                    // console.log(response)
                    showModalAction({
                        type: 'Alerts',
                        title: 'Perhatian!',
                        body: 'Anda telah menyelesaikan semua materi, silahkan melanjutkan ke langkah berikutnya!',
                        withbuttons: 'true',
                        actionbutton: 'Next',
                        showModal: () => window.location.assign(`/my-course/course_id=${modal.courseId}&material_id=${modal.firstMaterial}`)
                    })
                })
                .catch(response => {
                    console.log(response)
                    hideBackdropAction();
                });
        }
    }
    const handleSubmitQuiz = () => {
        handleOnClose();
        if(modal.action){
            modal.action(modal.actiondata, value, modal.video);
        }
        setValue(null)
    }
    const handleDone = () => {
        handleOnClose();
        showBackdropAction();
        if(modal.repeat){
            window.location.assign(modal.path)
        } else {
            api.post('/monitoring/video-view', {
                material_id: modal.id,
                time: modal.time,
                status: true,
            })
                .then(response => {
                    // console.log(response)
                    hideBackdropAction()
                    window.location.assign(modal.path)
                })
                .catch(response => {
                    console.log(response)
                    hideBackdropAction()
                });
        }
    }
    const handleChange = event => {
        setValue(event.target.value);
    };
    const handleToDashboard = () => {
        window.location.assign('/my-course')
    };
    const handleNext = () => {
        handleOnClose();
        modal.handleNext();
    }

    const handleUlang = () => {
        handleOnClose();
        modal.actiondata()
    }

    const handleClose = () => {
        if(modal.showOtherRedeem){
            setRedeemCode('')
            showModalAction({
                title: "Aktivasi Kelas Anda",
                type: 'activateCourse',
                label: "Submit",
                data: modal.data
            })
        } else if(modal.goToLink){
            window.open(modal.goToLink, "_blank", 'noopener,noreferrer')
            // showModalAction({
            //     type: 'tukarPoin',
            //     title: 'Selamat!',
            //     body: <>
            //         <p>Anda telah menyelesaikan pembelajaran dan mengumpulkan poin!</p>
            //         <p>Tukarkan poin Anda menjadi sebuah saldo e-wallet atau tambahkan lebih banyak poin dengan membeli pembelajaran baru. Teruskan perjalanan belajar Anda dan raih lebih banyak!</p>
            //         <a href='/tabungan-penunjang-karir/course'>[Klik di sini untuk menambah poin]</a>
            //     </>,
            //     redirect: '/tabungan-penunjang-karir',
            // })
            window.location.reload();
        } else { 
            if(modal.reload){
                window.location.reload();
            }
            if(modal.relog){
                sessionStorage.clear();
                localStorage.clear();
                window.location.assign('/login');
            }
            if(modal.refresh){
                window.location.reload();
            }
            if(modal.logout){
                sessionStorage.clear();
                localStorage.clear();
                window.location.assign('/');
            }
            if(modal.redirect){
                window.location.assign(modal.redirect);
            }

            handleOnClose();
        }
    }

    const handleConfim = () => {
        handleOnClose();
        modal.api(modal.dataApi)
    }

    const [redeemCode, setRedeemCode] = React.useState('');
    const handleActivateCode = (e) => {
        e.preventDefault()
        if(modal.isEdit){
            handleOnClose()
        } else {
            showBackdropAction()
            // api.post('/code/test', {code: redeemCode, user_id: modal.data.user_id, course_id: modal.data.id, status_code: 'success'})
            api.post('/code/commit', {code: redeemCode.trim(), user_id: modal.data.user_id, course_id: modal.data.id})
                .then(res => {
                console.log(res)
                if(res.data.success){
                    hideBackdropAction()
                    localStorage.setItem('babaRedirect', `/my-course/course_id=${modal.data.id}&material_id=${modal.data.material_id}`)
                    console.log(window.location.href, "SS")
                    window.location.href = res.data.data.url
                } else {
                    hideBackdropAction()
                    switch (res.data.code) {
                    case "ERRSIG43000":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Signature salah.`,
                        })
                        // setUser({message: "Signature salah."})
                        break;
                    case "ERRSIG43001":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `"Nilai Timestamp bukan integer.`,
                        })
                        // setUser({message: "Nilai Timestamp bukan integer."})
                        break;
                    case "ERRSIG43002":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Parameter ${'client_code'} tidak ditemukan atau salah`,
                        })
                        // setUser({message: `Parameter ${'client_code'} tidak ditemukan atau salah`})
                        break;
                    case "ERRSIG43003":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Timestamp yang dikirim lebih besar dari Timestamp Server"`,
                        })
                        // setUser({message: "Timestamp yang dikirim lebih besar dari Timestamp Server"})
                        break;
                    case "ERRSIG43004":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Signature expired`,
                        })
                        // setUser({message: "Signature expired"})
                        break;
                    case "ERRSIG43005":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Json Format pada Signature Invalid`,
                        })
                        // setUser({message: "Json Format pada Signature Invalid"})
                        break;
                    case "ERRTRX40028":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Gagal verifikasi, kode redeem bukan milik lembaga pelatihan.`,
                        })
                        // setUser({message: "Gagal verifikasi, kode redeem bukan milik lembaga pelatihan."})
                        break;
                    case "ERRPPA40005":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Pelatihan tidak ditemukan`,
                        })
                        // setUser({message: "Pelatihan tidak ditemukan"})
                        break;
                    case "ERRPLT40013":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Pelatihan tidak tersedia"`,
                        })
                        // setUser({message: "Pelatihan tidak tersedia"})
                        break;
                    case "ERRPPA40025":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Pelatihan tidak aktif`,
                        })
                        // setUser({message: "Pelatihan tidak aktif"})
                        break;
                    case "ERRTRX30002":
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: `Transaksi tidak ditemukan`,
                        })
                    // setUser({message: "-"})
                        break;
                    default:
                        showModalAction({
                            type: 'Alert',
                            title: 'Perhatian!',
                            body: res.data.message,
                            reload: true,
                        })
                        break;
                    }
                }
            })
            .catch(err => {
                hideBackdropAction()
                showModalAction({
                    type: 'Alert',
                    title: 'Perhatian!',
                    body: 'Redeem code tidak sesuai!',
                })
            })
        }
    }

    const handleBypass = () => {
        api.post('/monitoring/video-view', {
            material_id: modal.detailMateri.material.id,
            time: '1',
            status: '1',
          })
          .then(response => {
            window.location.assign(`/my-course/course_id=${modal.detailMateri.course.id}&material_id=${modal.detailMateri.nextMaterial.id}`)
          })
    }

    const handleChangeCode = (e) => {
        if(e.target.value === '888-' || e.target.value.includes('888-')){
            showModalAction({
                title: 'KODE REDEEM SALAH',
                body: 'Kamu memasukkan kode voucher pembelian. Masukkan kode redeem kamu dari dashboard prakerja.go.id',
                showOtherRedeem: true,
                data: modal.data
            })
        }

        if(modal.isEdit){
            modal.handle(e.target.value)
        }
        setRedeemCode(e.target.value)
    }

    const handleError = () => {
        const user = localStorage.getItem('loggedInUserBabaPrakerja') ? JSON.parse(localStorage.getItem('loggedInUserBabaPrakerja')).user : 
            {
                fullname: '',
                email: '',
                coupon: '',
            }
        
        const pesan = `${process.env.REACT_APP_MAIN_URL_FOOTER}%0ANama : ${user.fullname} %0AEmail : ${user.email} %0AURL : ${window.location.href} %0AKode Voucher : ${user.coupon ? user.coupon : ''} %0AKendala : `
        window.open(`https://wa.me/${process.env.REACT_APP_ADMIN_PHONE}?text=${pesan}`, '_blank');
    }

    const [coupons, setCoupons] = React.useState(modal.coupon ? modal.coupon : '')

    const handleChangeVoucher = (value) => {
        modal.edit(value)
        setCoupons(value)
    }

    const handleSubmitVoucher = (e) => {
        handleOnClose();
        e.preventDefault()
        modal.handleSubmit(e, coupons)
    }

    const [jawaban, setJawaban] = React.useState('')
    const handleSubmitJawaban = (e) => {
        e.preventDefault()
        showBackdropAction();
        handleOnClose();
        modal.ujian ? 
        api.post(`/exam-social-learnings/answers`, {
        course_id : modal.detail.course.id,
        answers : jawaban,
        exam_id : modal.ujian?.data?.exam_id
        })
        .then((response) => {
            hideBackdropAction()
            showModalAction({
                title: 'Perhatian!',
                body: 'Tugas Anda akan kami nilai dalam waktu 2 x 24 jam.',
                reload: true,
            })
            // window.location.reload()
            console.log(response, "OK")
        })
        .catch((response) => {
            hideBackdropAction()
            console.log("GOT")
        }) : 
        api.post(`/quiz/answer-task`, {
        course_id : modal.detail.course.id,
        task_link : jawaban,
        material_id: modal.detail.material.id,
        })
        .then((response) => {
            api.post('/monitoring/video-view', {
                material_id: modal.detail.material.id,
                time: '1',
                status: '1',
            }).then((response) => {
                hideBackdropAction()
                window.location.assign(`/my-course/course_id=${modal.detail.course.id}&material_id=${modal.detail.nextMaterial.id}`)
            })
            // window.location.reload()
        })
        .catch((response) => {
            hideBackdropAction()
            console.log("GOT")
        })
    }

    const handleDaftarNew = () => {
        handleOnClose();
        modal.handler();
    }

    const content = () => {
        switch (modal.type) {
            case "Register":
                return (
                    <DialogContentText>
                        <h3>{modal.body}</h3>
                        {modal.actiondata && <div>
                            <Typography variant="subtitle1" gutterBottom>
                                Nama  : <u><b>{modal.actiondata.fullname}</b></u><br/>
                                <b>Wajib sama dengan nama di KTP</b> <CheckIcon style={{color: 'green'}} />
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom>
                                Email : <u><b>{modal.actiondata.email}</b></u> <br/>
                                <b>Wajib sama dengan email di {modal.platformName}</b> <CheckIcon style={{color: 'green'}} />
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom>
                                <b>Password : Mudah anda ingat</b> <CheckIcon style={{color: 'green'}} />
                            </Typography>
                        </div>}
                    </DialogContentText>
                )
            case "ResetPassword":
                return (
                    <div>
                        {modal.componentpath}
                    </div>
                )
            case "Quiz":
                return (
                    <DialogContentText>
                        <h3>{modal.body}</h3>
                        {modal.actiondata && <div>
                            <RadioGroup aria-label="option" name="option" value={value} onChange={handleChange}>
                                <FormControlLabel value="A" control={<Radio color="primary" />} label={modal.actiondata.option_a} />
                                <FormControlLabel value="B" control={<Radio color="primary" />} label={modal.actiondata.option_b} />
                                <FormControlLabel value="C" control={<Radio color="primary" />} label={modal.actiondata.option_c} />
                                <FormControlLabel value="D" control={<Radio color="primary" />} label={modal.actiondata.option_d} />
                            </RadioGroup>
                        </div>}
                    </DialogContentText>
                )
            case "Done":
                return (
                    <DialogContentText>
                        <h3>{modal.body}</h3>
                    </DialogContentText>
                )
            case "Voucher":
                return (
                    <DialogContentText style={{textAlign: "center"}}>
                        {modal.icon}
                        <h3>{modal.body}</h3>
                    </DialogContentText>
                )
            case "VoucherGagal":
                return (
                    <DialogContentText style={{textAlign: "center"}}>
                        {modal.icon}
                        <h3>{modal.body}</h3>
                        <h3>Contoh kode voucher :</h3>
                        <IconButton onClick={() => modal.nextModal({type: "ContohVoucher", title: 'Contoh Tokopedia', body: 'Berikut adalah contoh voucher Tokopedia', image: modal.data.tokped})} aria-label="delete">
                            <img src={Tokopedia} style ={{height: '100px', width: '100px'}} alt="Tokopedia" />
                        </IconButton>
                        <IconButton onClick={() => modal.nextModal({type: "ContohVoucher", title: 'Contoh Bukalapak', body: 'Berikut adalah contoh voucher Bukalapak', image: modal.data.bl})} aria-label="delete">
                            <img src={BukaLapak} style ={{height: '100px', width: '100px'}} alt="BukaLapak" />
                        </IconButton>
                        <IconButton onClick={() => modal.nextModal({type: "ContohVoucher", title: 'Contoh Kemnaker', body: 'Berikut adalah contoh voucher Kemnaker', image: modal.data.kemnaker})} aria-label="delete">
                            <img src={Kemnaker} style ={{height: '100px', width: '100px'}} alt="Kemnaker" />
                        </IconButton>
                        {/* <IconButton onClick={() => modal.nextModal({type: "ContohVoucher", title: 'Contoh Techfor.id', body: 'Berikut adalah contoh voucher Techfor.id', image: modal.data.techfor})} aria-label="delete">
                        <img src={Techfor} style ={{height: '100px', width: '100px'}} alt="Techfor" />
                    </IconButton>
                    <IconButton onClick={() => modal.nextModal({type: "ContohVoucher", title: 'Contoh SekolahPintar', body: 'Berikut adalah contoh voucher SekolahPintar', image: modal.data.sekolahpintar})} aria-label="delete">
                        <img src={SekolahPintar} style ={{height: '100px', width: '170px'}} alt="SekolahPintar" />
                    </IconButton> */}
                        <br />
                        <Button color="primary" href='/tanya-cs' variant="contained" >Hubungi CS</Button>
                    </DialogContentText>
                )
            case "ContohVoucher":
                return (
                    <DialogContentText style={{textAlign: "center"}}>
                        <img src={modal.image} alt={modal.image} className={classes.image} />
                    </DialogContentText>
                )
            case "activateCourse":
                return (
                    <DialogContentText style={{textAlign: "center"}}>
                        <form onSubmit={handleActivateCode}>
                            <TextField
                                label="Redeem Code"
                                placeholder="Masukkan redeem code yang anda peroleh dari prakerja.go.id"
                                // helperText="Full width!"
                                type="text"
                                fullWidth
                                onChange={handleChangeCode}
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    style: {
                                        backgroundColor: '#ffffff'
                                    }
                                }}
                                variant="outlined"
                                value={modal.isEdit ? null : redeemCode}
                                required
                            />
                            <Button fullWidth className='my-2' type='submit' color="primary" variant="contained">
                                {modal.label}
                            </Button>
                            <LazyLoadImage
                                alt={"CONTOH KODE REDEEM"}
                                effect="blur"
                                width="100%"
                                height="100%"
                                onError={(e) => {e.target.onerror = null; e.target.src="https://miro.medium.com/max/3202/1*L5IJM6n8N4wiwqRgoZrWaw.png"}}
                                src={process.env.REACT_APP_REDEEM_SAMPLE}
                            />
                            {/* <Button className='my-2' fullWidth color="primary" variant="contained" onClick={() => window.open(process.env.REACT_APP_VOUCHER_LINK, '_blank')}>Cara dapatkan Redeem Code</Button> */}
                        </form>
                    </DialogContentText>
                )
            // case "registerFail":
            //     return (
            //         <DialogContentText style={{textAlign: "center"}}>
            //             <TextField
            //                 label="Kode voucher yang kamu masukkan"
            //                 type="text"
            //                 disabled
            //                 fullWidth
            //                 margin="normal"
            //                 InputLabelProps={{
            //                     shrink: true,
            //                 }}
            //                 inputProps={{
            //                     style: {
            //                         backgroundColor: '#ffffff'
            //                     }
            //                 }}
            //                 variant="outlined"
            //                 value={modal.voucher}
            //                 required
            //             />
            //         </DialogContentText>
            //     )
            case "isError":
                return (
                    <DialogContentText style={{textAlign: "center"}}>
                        <h3>Mohon maaf sedang terjadi kesalahan. Silahkan hubungi admin!</h3>
                    </DialogContentText>
                )
            case 'kodeVoucher': 
                return (
                    <DialogContentText style={{textAlign: "center"}}>
                        <h3>Masukkan Kode Voucher</h3>
                        <form onSubmit={handleSubmitVoucher} className='text-center'>
                            <modal.CustomInput className='my-2' placeholder="Masukkan Kode Voucher" fullWidth inputComponent={modal.TextMaskCustom} defaultValue={modal.coupon} value={coupons} onChange={e => handleChangeVoucher(e.target.value)} />
                            <Button className='my-2' fullWidth color="primary" variant="contained" type="submit">Submit</Button>
                            <Typography variant="h6">Contoh kode voucher</Typography>
                            <LazyLoadImage
                                alt={"CONTOH KODE VOUCHER"}
                                effect="blur"
                                width="100%"
                                height="100%"
                                onError={(e) => {e.target.onerror = null; e.target.src="https://miro.medium.com/max/3202/1*L5IJM6n8N4wiwqRgoZrWaw.png"}}
                                src={process.env.REACT_APP_VOUCHER_SAMPLE}
                                />
                        </form>   
                    </DialogContentText>
                )
            case 'resubmit':
                return (
                <form onSubmit={handleSubmitJawaban}>
                    <Typography variant="h6" className={classes.uppercase}>Silahkan submit ulang jawaban Anda</Typography>
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                    <FormControl variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-review">Link Jawaban</InputLabel>
                        <OutlinedInput
                            style={{marginTop: 10}}
                            id="outlined-adornment-review"
                            onChange={(event) => setJawaban(event.target.value)}
                            labelWidth={95}
                            inputProps={{ maxLength: 250 }}
                            required    
                            type='url'
                        />
                        <Button variant="contained" color="primary" type="submit" className={classes.button}>Kirim</Button>
                    </FormControl>
                    </div>
                </form>
                )
            default:
                return (
                    <DialogContentText>
                        <h3>{modal.body}</h3>
                    </DialogContentText>
                )
        }
    }

    return (
        <Dialog
            className={classes.dialog}
            disableBackdropClick
            disableEscapeKeyDown
            open={modal.show}
            onClose={handleOnClose}
            fullWidth={true}
            maxWidth='sm'
            PaperProps={{
                style: {
                    borderRadius: '16px',
                },
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">

            <DialogTitle type={modal.type} onClose={handleOnClose} style={{textAlign: 'center'}}>
                <Typography variant="h4" style={{fontWeight: '600'}}>{modal.title && modal.title}</Typography>
                {modal.hideXButton ? null : <IconButton aria-label="close" className={classes.closeButton} onClick={handleOnClose}>
                    <CloseIcon />
                </IconButton> }
            </DialogTitle>
            <DialogContent>
                <Suspense fallback={<CircularProgress />}>
                    {modal.componentpath ? (
                        <modal.componentpath {...modal.componentProps} />
                    ) : (
                        <div>
                            {content()}
                        </div>
                    )}
                </Suspense>
            </DialogContent>
            <DialogActions {...modal} style={{padding: '20px'}}>
                 {(modal.daftarNew) && 
                <Button onClick={handleDaftarNew} color="primary" variant="contained">
                    Daftar
                </Button>
                }{(modal.cs || modal.type === 'Alert') && 
                <Button style={{backgroundColor: 'green'}} onClick={handleError} color="primary" variant="contained">
                    Hubungi CS
                </Button>
                }
                {modal.type === 'registerFail' && 
                <Button onClick={() => window.open(`https://wa.me/${process.env.REACT_APP_ADMIN_PHONE}`, '_blank')} color="danger" variant="contained">
                    Kontak CS
                </Button>
                }
                {modal.is_bypass &&
                <Button onClick={handleBypass} color="primary" variant="contained">
                    Bypass
                </Button>
                }
                {/* {modal.type === "activateCourse" && 
                <Button onClick={handleActivateCode} color="primary" variant="outlined">
                    {modal.label}
                </Button>
                } */}
                {modal.linkLiveSession !== undefined &&
                <Button href={modal.linkLiveSession} color="primary" variant="outlined">
                    Ikuti Live Session
                </Button>
                }
                {modal.webinar &&
                <Button href={`/live-session_id=${modal.courseId}`} color="primary" variant="outlined">
                    Ikuti Webinar
                </Button>
                }
                {modal.ulang &&
                    <Button onClick={handleUlang} color="primary" variant="contained">
                        Ya
                    </Button>
                }
                {modal.type === "Quiz" &&
                    <Button onClick={handleSubmitQuiz} disabled={value === null ? true : false} color="primary" variant="contained" >
                        Submit
                </Button> 
                }
                {modal.closeButton &&
                    <Button onClick={handleClose} color="secondary" variant="contained" >
                        Tutup
                    </Button>
                }
                {modal.withoutClose ? null : modal.withbuttons ? '' : 
                    <Button onClick={modal.type === "Dashboard" ? handleToDashboard : handleClose} color={modal.type === 'registerFail' ? 'primary' : "secondary"} variant="contained" >
                        {modal.type === 'vermuk'? "Verifikasi sekarang" : modal.type === 'tukarPoin' ? "Tukar Poin" : modal.type === "registerFail" ? "Coba Ulang" : modal.type === "Confirm" ? "Salah" : modal.relog ? "Masuk Lagi" : modal.goToLink ? "Download sekarang" : modal.refresh ? "Ulangi" : "Tutup"}
                    </Button>
                }
                {modal.type === "Confirm" && 
                <Button onClick={handleConfim} color="primary" variant="contained">
                    {modal.label}
                </Button>
                }
                {modal.repeat &&
                <Button onClick={() => window.location.reload()} color="primary" variant="outlined">
                    Ulangi Quiz
                </Button>
                }
                {modal.playVideo &&
                <Button onClick={handleClose} color="secondary" variant="outlined">
                    Lanjut nonton
                </Button>
                }
                {modal.withbuttons && (
                    <React.Fragment>
                        {(modal.type === "Done" && modal.path !== null) ?
                            <Button onClick={handleDone} color="primary" variant="contained">
                                {modal.actionbutton}
                            </Button> :
                            <Button onClick={handleSubmit} color="primary" variant="contained">
                                {modal.actionbutton}
                            </Button>
                        }
                    </React.Fragment>
                )}
            </DialogActions>
        </Dialog>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDetailApi: (path) => dispatch(actionTypesMateri.getDetailApi(path)),
        showBackdropAction: () => dispatch(actionTypesBackdrop.showBackdropAction()),
        hideBackdropAction: () => dispatch(actionTypesBackdrop.hideBackdropAction()),
        showModalAction: (object) => dispatch(actionTypesModal.showModalAction(object)),
    }
}

export default connect(null, mapDispatchToProps)(ModalWrapper);
